export default __webpack_public_path__ + "static/media/stainRemover.90ef5a33.svg";